import { onceVisible } from '@/modules/public/shared/concierge/concierge';

function track(element, interaction) {
  App.track.event('location_page_interaction', {
    section: 'concierge_banner',
    element,
    element_value: '',
    interaction,
  });
}

export function init() {
  const banner = document.querySelector('.js-concierge-banner');

  if (!banner) {
    return;
  }

  onceVisible(banner, () => track('concierge_banner', 'visible'));

  banner.querySelector('.js-concierge-banner-link').addEventListener('click', () => {
    track('submit_brief_link', 'click');
  });
}
